import { RouteItem } from '@eastcoal/router/types/route'

import { EMPLOYEE_PERFORMANCE_PAGE_UUID } from './constants/uuid'

export const employeePerformanceRoute: RouteItem = {
  title: '员工绩效',
  uuid: EMPLOYEE_PERFORMANCE_PAGE_UUID,
  path: '/employeePerformance',
  Component: () => import('./index')
}
